import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Grid } from "@mui/material";
import { LogoMain } from "./components/LogoMain";
import AuthDivider from "./components/AuthDivider";
import AuthWrapper from "./components/AuthWrapper";
import { GoogleLogo } from "./components/GoogleLogo";
import { useGoogleLogin } from "@react-oauth/google";
import { enqueueSnackbar } from "notistack";

const Login = () => {
  const navigate = useNavigate();
  const googleLogin = useGoogleLogin({
    onSuccess: (response) => {
      const accessToken = response.access_token;

      localStorage.setItem("__ac_user", accessToken);
      navigate("/home", { replace: true });
    },
    onError: (error) => {
      enqueueSnackbar(
        <span>
          Something went wrong with logging in
          <br />
          <span style={{ fontSize: 10 }}>Error: {error?.error}</span>
        </span>,
        {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        }
      );
    },
  });

  const handleLoginClick = () => {
    googleLogin();
  };

  return (
    <AuthWrapper>
      <Grid container spacing={3}>
        <Grid item xs={12} sx={{ textAlign: "center" }}>
          <LogoMain width="150px" />
        </Grid>
        <Grid item xs={12} mt={-2}>
          <button className="google-login-button" onClick={handleLoginClick}>
            <GoogleLogo />
            <span>Continue with Google</span>
          </button>
          <Box mt={2}>
            <AuthDivider>
              <Typography variant="body1">Don't have an account?</Typography>
            </AuthDivider>
            <Typography mt={2} variant="body2" textAlign="center">
              Send a Slack message to{" "}
              <a
                style={{
                  textDecoration: "underline",
                  color: "purple",
                }}
                href="mailto:shai@appcharge.com"
              >
                Shai
              </a>{" "}
              to create one.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </AuthWrapper>
  );
};

export default Login;
